import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { SubActivityForm } from '@/components/activities/SubActivityForm';
import { PageContainer } from '@/components/layout/PageContainer';
import { AppBreadcrumbs } from '@/components/layout/AppBreadcrumbs';

export const SubActivityFormPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const parentActivityId = parseInt(id || '0');

  const handleSuccess = () => {
    // Navigate back to the parent activity
    navigate(`/activities/${parentActivityId}`);
  };

  return (
    <PageContainer width="default" className="space-y-4">
      <AppBreadcrumbs />
      <SubActivityForm 
        parentActivityId={parentActivityId}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
};
